import React from "react";
import "./header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IsAuthenticated } from "helpers";
import { Logout } from "api-services";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "bootstrap";
function MobileNav({ images }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = IsAuthenticated();

  const handleNavigation = (path) => () => navigate(path);

  const renderApiButton = (apiName, apiDescription, imgSrc) => (
    <li className="d-flex">
      <img
        src={imgSrc}
        alt={`${apiName} API`}
        className="img-fluid pt-1"
        width={30}
        height={30}
      />
      <button
        className="dropdown__link"
        onClick={handleNavigation(
          isAuthenticated ? "/products" : "/authentication/sign-up"
        )}
      >
        <span className="nav-title"> {apiName} </span>
        <span className="nav-desc">{apiDescription}</span>
      </button>
    </li>
  );

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <nav className="navbar navbar-dark d-block d-lg-none px-0 pt-4">
      <div className="container-fluid">
        <div className="navbar-brand">
          <Link to="/dashboard" className="navbar__brand">
            <img src={images.Logo} alt="Gato Systems" />
          </Link>
        </div>
        <button
          className={isHomePage ? " navbar-toggler " : "navbar-toggler darknav"}
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasDarkNavbar"
          aria-controls="offcanvasDarkNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="offcanvas offcanvas-start text-bg-dark"
          tabIndex="-1"
          id="offcanvasDarkNavbar"
          aria-labelledby="offcanvasDarkNavbarLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasDarkNavbarLabel">
              <Link to="/dashboard" className="navbar__brand">
                <img src={images.LogoLight} alt="Gato Systems" />
              </Link>
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav justify-content-start flex-grow-1 pe-3">
              {renderApiButton(
                "Account Opening API",
                "Onboard new users",
                images.AccountOpening
              )}
              {renderApiButton(
                "Funding API",
                "Custom workflows",
                images.FundsApproval
              )}
              {renderApiButton(
                "Trading API",
                "Trade equities, options, monitor positions",
                images.OMS
              )}
              {renderApiButton(
                "FIX Specifications",
                "Harness the power of our FIX infrastructure in your products",
                images.Fix
              )}
              <li className="d-flex py-3">
                {isAuthenticated ? (
                  <div className="d-flex flex-column align-items-baseline">
                    <button
                      className="navbar__link mb-3"
                      onClick={handleNavigation("/dashboard")}
                    >
                      <img
                        src={images.Dashboard}
                        alt="Dashboard"
                        className="img-fluid mb-md-2"
                        width={32}
                        height={32}
                      />{" "}
                      Dashboard
                    </button>
                    <button
                      className="navbar__link mb-3"
                      onClick={handleNavigation("/profile")}
                    >
                      <img
                        src={images.Profile}
                        alt="Profile"
                        className="img-fluid mb-md-2"
                        width={32}
                        height={32}
                      />{" "}
                      Profile
                    </button>
                    <button
                      className="navbar__link mb-3"
                      onClick={() => Logout(dispatch, navigate)}
                    >
                      <img
                        src={images.Signout}
                        alt="Signout"
                        className="img-fluid mb-md-2"
                        width={32}
                        height={32}
                      />{" "}
                      Sign Out
                    </button>
                  </div>
                ) : (
                  <button
                    className="navbar__link"
                    onClick={handleNavigation("/authentication/sign-in")}
                  >
                    Sign In
                  </button>
                )}
              </li>
              <li className="d-flex py-3">
                {!isAuthenticated && (
                  <button
                    className="btn btn-reg inside"
                    onClick={handleNavigation("/authentication/sign-up")}
                  >
                    Register
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

MobileNav.propTypes = {
  images: PropTypes.shape({
    Logo: PropTypes.string.isRequired,
    LogoLight: PropTypes.string.isRequired,
    AccountOpening: PropTypes.string.isRequired,
    FundsApproval: PropTypes.string.isRequired,
    OMS: PropTypes.string.isRequired,
    Fix: PropTypes.string.isRequired,
    Dashboard: PropTypes.string.isRequired,
    Profile: PropTypes.string.isRequired,
    Signout: PropTypes.string.isRequired,
  }).isRequired,
};
export default MobileNav;
